import { compose } from 'recompose';

import FilesItem from './filesItem';

const enhance = compose();

export default enhance(FilesItem);
